import React from "react";
import { useNavigate } from "react-router-dom";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowRight } from "@fortawesome/free-solid-svg-icons";
import logo from "../assets/images/arabic-english-horizontal-red-box-white-text.png";
import theme from "../styles/theme";
import { Tooltip as ReactTooltip } from "react-tooltip";

import "../styles/header.css";

function Header() {
  const navigate = useNavigate();
  const handleLogoClick = () => {
    navigate("/");
  };
  const changeLanguage = () => {
    localStorage.setItem("lang", "ar");
    window.location.reload();
  };

  return (
    <div style={{ cursor: "pointer" }}>
      <nav class="navbar">
        <div className="header-logo" onClick={handleLogoClick}>
          <img src={logo} alt="Khayrallah Center logo" />
        </div>
        <div className="nav-items">
          <div className="give-button">
            <a
              className="btn rounded-0"
              style={{ backgroundColor: theme.colors.mainRed }}
              href="https://www.givecampus.com/campaigns/47387/donations/new?a=8830926&designation=089252"
            >
              <span style={{ color: "#FFFFFF" }}>Give Now</span>&nbsp;&nbsp;
              <FontAwesomeIcon
                style={{ color: "#FFFFFF" }}
                icon={faArrowRight}
              />
            </a>
          </div>
          <div className="new-button">
            <button
              className="btn btn btn-outline-dark rounded-0 corner-button"
              data-tooltip-id="arabic-tooltip"
              data-tooltip-content="Arabic UI"
              onClick={changeLanguage}
            >
              عربي
            </button>
            <ReactTooltip id="arabic-tooltip" place="bottom" effect="solid" />
          </div>
        </div>
      </nav>
    </div>
  );
}

export default Header;
